<template>
  <div class="item w-9/12 mb-6 md:mb-12 flex items-center" @click="$emit('click')">
    <img :src="item.img" class="mr-4" />
    <div class="text-sm sm:text-xl">{{ item.name }}</div>
    <div v-if="item.target" class="target pl-4 truncate flex-1 text-xs text-right">
      {{ item.target }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  max-width: 420px;
}

.target {
  color: #6a6a6a;
}
</style>
